var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cp\u003E[ \u003Ca href=\"\u002Fhelp#toc\"\u003E" + (pug.escape(null == (pug_interp = __('Table of contents')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E ]\u003C\u002Fp\u003E";;return pug_html;};
module.exports = template;